import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
  now: 0,
  activity: {
    dailyAllotment: 0,
    total: 0
  }
}

const mutations = {
  setDate(state, date) {
    state.now = date
  }
}

const actions = {
  tick({ commit }) {
    setTimeout(() => {
      commit('setDate', new Date())
    }, 1000);
  }
}

export default new Vuex.Store({
  state,
  actions,
  mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js